<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field v-model="value" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'TextDialog',
    data: () => ({
      dialog: false,
      value: ""
    }),
    props:{
        title: String,
        onChanged: Function
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog
    },
    methods: {
      show: function(value){
        this.value = value;
        this.dialog = true;
      },
      save: function(){
        this.onChanged(this.value);
        this.dialog = false;
      }
    },
    mounted: function(){
      
    }
  }
</script>